<div class="row">
    <label class="col-form-label d-flex" style="font-weight: bolder; font-size: x-large;">Customer
        Dashboard</label>
    <div class="card">
        <div class="card-body">
            <div class="row align-items-end">
                <div class="col-sm-3">
                    <label class="col-form-label" for="searchMobileNumber">Customer Contact Number</label>
                    <input class="form-control" id="searchMobileNumber" [(ngModel)]="searchMobileNumber" type="text" name="searchMobileNumber">
                </div>
                <!-- <div class="col-sm-3">
                    <label class="col-form-label" for="searchEmailId">Customer Email Id </label>
                    <input class="form-control" id="searchEmailId" [(ngModel)]="searchEmailId" type="email"
                        name="searchEmailId">
                </div> -->
                <div class="col-sm-3">
                    <label class="col-form-label" for="searchEmailId">Customer CINE ID </label>
                    <input class="form-control" id="searchCineId" [(ngModel)]="searchCineId" type="text"
                        name="searchCineId">
                </div>
                <div class="col-sm-3">
                    <label class="col-form-label" for="searchWalletId">Customer Wallet ID </label>
                    <input class="form-control" id="searchWalletId" [(ngModel)]="searchWalletId" type="text" name="searchWalletId">
                </div>
                <div class="col-sm-3">
                    <button class="btn btn-primary w-100" (click)="search()">
                        <i class="fa fa-search me-1"></i> Search
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row mt-2" [ngStyle]="{ 'display': displayDetails ? 'block' : 'none' }">
    <div class="card" style="border-color: aliceblue !important;">
        <div class="card-body">
            <div class="d-grid gap-2 d-flex">
                <button class="btn btn-primary" (click)="this.selectedTab=0" [class.active]="selectedTab==0"
                    type="button">Personal Details</button>
                <button class="btn btn-primary" (click)="this.selectedTab=1" [class.active]="selectedTab==1"
                    type="button">Device Information</button>
                <button class="btn btn-primary" (click)="this.selectedTab=2" [class.active]="selectedTab==2"
                    type="button">Wallet Details</button>
                <button class="btn btn-primary" (click)="this.selectedTab=3" [class.active]="selectedTab==3"
                    type="button">KYC Documents</button>
                <button class="btn btn-primary"  *ngIf="isOperationsUser" (click)="this.selectedTab=4" [class.active]="selectedTab==4"
                    type="button">Beneficiaries</button>
                <button class="btn btn-primary" (click)="this.selectedTab=5; fetchTransactionDetails()" [class.active]="selectedTab==5"
                    type="button">Transaction Details</button>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==0 ? 'block' : 'none' }">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">Personal Details</h5>
            <!-- Single Unmask Button for All PII Fields -->
            <button
                type="button"
                class="btn bg-danger-custom btn-sm"
                (click)="unmaskAllPiiFields()"
                title="Unmask All PII Fields">
                <img src="assets/images/unmask-icon.png" alt="Unmask All" style="width: 16px; height: 16px; margin-right: 5px; filter: brightness(0) invert(1);">
                Unmask All PII
            </button>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-sm-4">
                    <label class="col-form-label" for="customerName">Customer Name</label>
                    <input class="form-control" readonly id="customerName" [(ngModel)]="personalDetails.fullName"
                        type="text" name="customerName">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="customerEmail">Customer Email</label>
                    <input class="form-control" readonly id="customerEmail" [(ngModel)]="personalDetails.email" type="text"
                        name="customerEmail">
                </div>
                <div class="col-sm-4">
                    <!-- PII Field Component with built-in label -->
                    <app-pii-field
                        fieldName="governmentId"
                        [encryptedValue]="personalDetails.governmentId"
                        [userId]="personalDetails.userId"
                        label="Document ID"
                        [visibleStart]="3"
                        [visibleEnd]="1"
                        [showLabel]="true"
                        [readonly]="true">
                    </app-pii-field>
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="expiryDate">Document ID Expiry</label>
                    <input class="form-control" readonly id="expiryDate" [(ngModel)]="personalDetails.expiryDate"
                        type="text" name="expiryDate">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="registeredMobileNumber">Registered Contact Number</label>
                    <input class="form-control" readonly id="registeredMobileNumber" [(ngModel)]="personalDetails.registeredMobileNumber"
                        type="text" name="registeredMobileNumber">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="nationality">Nationality</label>
                    <input class="form-control" readonly id="nationality" [(ngModel)]="personalDetails.nationality"
                        type="text" name="nationality">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="dateOfBirth">Date of Birth</label>
                    <input class="form-control" readonly id="dateOfBirth" [(ngModel)]="personalDetails.dateOfBirth"
                        type="text" name="dateOfBirth">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="gender">Gender</label>
                    <input class="form-control" readonly id="gender" [(ngModel)]="personalDetails.gender" type="text"
                        name="gender">
                </div>
                <div class="col-sm-4" *ngIf="isOperationsUser">
                    <label class="col-form-label" for="passportNumber">Passport Number</label>
                    <input class="form-control" readonly id="passportNumber" [(ngModel)]="personalDetails.passportNumber"
                        type="text" name="passportNumber">
                </div>
                <div class="col-sm-4" *ngIf="isOperationsUser">
                    <label class="col-form-label" for="passportExpiryDate">Passport Expiry Date</label>
                    <input class="form-control" readonly id="passportExpiryDate"
                        [(ngModel)]="personalDetails.passportExpiryDate" type="text" name="passportExpiryDate">
                </div>
                <div class="col-sm-4" *ngIf="isOperationsUser">
                    <label class="col-form-label" for="occupation">Occupation</label>
                    <input class="form-control" readonly id="occupation" [(ngModel)]="personalDetails.occupation"
                        type="text" name="occupation">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="placeOfBirth">Place of Birth</label>
                    <input class="form-control" readonly id="placeOfBirth" [(ngModel)]="personalDetails.placeOfBirth"
                        type="text" name="placeOfBirth">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="address">Address</label>
                    <input class="form-control" readonly id="address" [(ngModel)]="addressFormatted" type="text"
                        name="address">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="sourceOfFund">Source Of Fund</label>
                    <input class="form-control" readonly id="sourceOfFund" [(ngModel)]="personalDetails.sourceOfFund"
                        type="text" name="sourceOfFund">
                </div>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==1 ? 'block' : 'none' }">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-4">
                    <label class="col-form-label" for="appVersion">App Version</label>
                    <input class="form-control" readonly id="appVersion" [(ngModel)]="deviceDetails.appVersion"
                        type="text" name="appVersion">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="deviceType">OS Type</label>
                    <input class="form-control" readonly id="deviceType" [(ngModel)]="deviceDetails.deviceType" type="text" name="deviceType">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="version">OS Version</label>
                    <input class="form-control" readonly id="version" [(ngModel)]="deviceDetails.version" type="text"
                        name="version">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="deviceId">Device ID</label>
                    <input class="form-control" readonly id="deviceId" [(ngModel)]="deviceDetails.deviceId" type="text" name="deviceId">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="model">Device Model</label>
                    <input class="form-control" readonly id="model" [(ngModel)]="deviceDetails.model" type="text" name="model">
                </div>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==2 ? 'block' : 'none' }">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-4">
                    <label class="col-form-label" for="walletId">Wallet ID</label>
                    <input class="form-control" readonly id="walletId" [(ngModel)]="walletDetails.walletId" type="text"
                        name="walletId">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="walletBalance">Wallet Balance</label>
                    <input class="form-control" readonly id="walletBalance" [(ngModel)]="walletDetails.walletBalance" type="text" name="walletBalance">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="virtualIban">Virtual IBAN</label>
                    <input class="form-control" readonly id="virtualIban" [(ngModel)]="walletDetails.virtualIban" type="text" name="virtualIban">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="virtualIbanStatus">Virtual IBAN Status</label>
                    <input class="form-control" readonly id="virtualIbanStatus" [(ngModel)]="walletDetails.virtualIbanStatus"
                        type="text" name="virtualIbanStatus">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="virtualIbanCreationDate">Virtual IBAN Creation Date</label>
                    <input class="form-control" readonly id="virtualIbanCreationDate" [(ngModel)]="walletDetails.virtualIbanCreationDate" type="text"
                        name="virtualIbanCreationDate">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="virtualIbanClosureDate">Virtual IBAN Closure Date</label>
                    <input class="form-control" readonly id="virtualIbanClosureDate"
                        [(ngModel)]="walletDetails.virtualIbanClosureDate" type="text" name="virtualIbanClosureDate">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="walletStatus">Wallet Status</label>
                    <input class="form-control" readonly id="walletStatus" [(ngModel)]="personalDetails.status"
                        type="text" name="walletStatus">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="referralCode">Referral Code</label>
                    <input class="form-control" readonly id="referralCode" [(ngModel)]="walletDetails.referralCode" type="text"
                        name="referralCode">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="walletCreationDate">Wallet Creation Date</label>
                    <input class="form-control" readonly id="walletCreationDate"
                        [(ngModel)]="walletDetails.walletCreationDate" type="text" name="walletCreationDate">
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="walletClosureDate">Wallet Closure Date</label>
                    <input class="form-control" readonly id="walletClosureDate" [(ngModel)]="walletDetails.walletClosureDate"
                        type="text" name="walletClosureDate">
                </div>
                <div class="col-sm-4 mt-4">
                    <button class="btn btn-primary mt-3"  *ngIf="personalDetails.status=='SUSPENDED'" (click)="unfreezeAccount()"
                    type="button">Unfreeze</button>
                </div>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==3 ? 'block' : 'none' }">
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <br />
                    <!-- <p><strong>Emirates ID Front</strong></p>
                    <img [src]="personalDetails.frontImageDocUrl" height="300px" alt="" id="emiratesIdFront"> -->
                    <div class="kyc-document-section">
                        <div class="cnie-doc-box">
                            <i class="feather icon-file-text cnie-doc-icon"></i>
                            <h6 class="cnie-doc-title">CNIE Front Image</h6>
                            <p class="cnie-doc-text">This document contains PII data</p>
                            <button type="button" class="btn btn-primary" (click)="viewCnieDocument('CIN_FRONT', 'CNIE Front Image')">
                                <i class="feather icon-eye"></i>View CNIE Front Image
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <br />
                    <!-- <p><strong>Emirates ID Back</strong></p> -->
                    <!-- <img [src]="personalDetails.backImageDocUrl" height="300px" alt="" id="emiratesIdBack"> -->
                    <div class="kyc-document-section">
                        <div class="cnie-doc-box">
                            <i class="feather icon-file-text cnie-doc-icon"></i>
                            <h6 class="cnie-doc-title">CNIE Back Image</h6>
                            <p class="cnie-doc-text">This document contains PII data</p>
                            <button type="button" class="btn btn-primary" (click)="viewCnieDocument('CIN_BACK', 'CNIE Back Image')">
                                <i class="feather icon-eye"></i>View CNIE Back Image
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==4 ? 'block' : 'none' }">
        <div class="card-header">
            <h5 class="card-title mb-0">Beneficiaries</h5>
        </div>
        <div class="card-body">
            <div class="row mb-3">
                <div class="col-md-6">
                    <div class="d-flex gap-2" role="group">
                        <button type="button" class="btn btn-primary flex-fill"
                            [class.active]="beneficiaryFilterType === 'all'"
                            (click)="onBeneficiaryFilterTypeChange('all')">
                            All Beneficiaries
                        </button>
                        <button type="button" class="btn btn-primary flex-fill"
                            [class.active]="beneficiaryFilterType === 'domestic'"
                            (click)="onBeneficiaryFilterTypeChange('domestic')">
                            Domestic
                        </button>
                        <button type="button" class="btn btn-primary flex-fill"
                            [class.active]="beneficiaryFilterType === 'international'"
                            (click)="onBeneficiaryFilterTypeChange('international')">
                            International
                        </button>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-md-3" *ngIf="beneficiaryFilterType !== 'domestic'">
                    <label class="col-form-label" for="beneficiaryCountry">Country</label>
                    <select class="form-control" id="beneficiaryCountry"
                        [(ngModel)]="beneficiaryFilterCountry">
                        <option value="">All Countries</option>
                        <option *ngFor="let country of countryDropDown" [value]="country.id">{{country.name}}</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="col-form-label" for="beneficiaryRelation">Relation</label>
                    <select class="form-control" id="beneficiaryRelation"
                        [(ngModel)]="beneficiaryFilterRelation">
                        <option value="">All Relations</option>
                        <option *ngFor="let relation of relationshipDropDown" [value]="relation.purpose">{{relation.purpose}}</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="col-form-label" for="beneficiaryBankType">Type (Bank/UPI)</label>
                    <select class="form-control" id="beneficiaryBankType"
                        [(ngModel)]="beneficiaryFilterBankType">
                        <option value="">All</option>
                        <option value="BANK">Bank</option>
                        <option value="RTPS">UPI</option>
                    </select>
                </div>
                <div class="col-md-3 d-flex align-items-end">
                    <button class="btn btn-primary me-2 w-100" (click)="onBeneficiaryFilterTypeChange(beneficiaryFilterType)">
                        Apply Filters
                    </button>
                    <button class="btn btn-secondary w-100" (click)="resetBeneficiaryFilters()">
                        <i data-feather="rotate-ccw" class="icon-sm"></i> Reset Filters
                    </button>
                </div>
            </div>

            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine"
                style="margin-bottom: 0px; min-height: 300px">
                <ag-grid-angular [enableCellTextSelection]=true [columnDefs]="tableSelectedColumn"
                    [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [rowData]="beneficiaryDetails"
                    [rowModelType]="" [rowSelection]="'single'" [suppressPaginationPanel]="true"
                    style="width: 100%; height: auto;">
                </ag-grid-angular>
            </div>
        </div>
    </div>
    <div class="card" [ngStyle]="{ 'display': selectedTab==5 ? 'block' : 'none' }">
        <div class="card-header">
            <h5 class="card-title mb-0">Transaction Details</h5>
        </div>
        <div class="card-body">
            <div class="row mb-3">
                <div class="col-md-6">
                    <div class="d-flex gap-2" role="group">
                        <button type="button" class="btn btn-primary flex-fill"
                            [class.active]="transactionFilterType === 'all'"
                            (click)="onTransactionFilterTypeChange('all')">
                            All Transactions
                        </button>
                        <button type="button" class="btn btn-primary flex-fill"
                            [class.active]="transactionFilterType === 'domestic'"
                            (click)="onTransactionFilterTypeChange('domestic')">
                            Domestic
                        </button>
                        <button type="button" class="btn btn-primary flex-fill"
                            [class.active]="transactionFilterType === 'international'"
                            (click)="onTransactionFilterTypeChange('international')">
                            International
                        </button>
                    </div>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-3">
                    <button type="button" class="btn btn-primary w-100" (click)="toggleTransactionFilter()">
                        <i class="fa fa-filter me-1"></i> Filter
                    </button>
                </div>
            </div>
            <div *ngIf="transactionFilterShow" class="card mb-3">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <label class="col-form-label" for="transactionFilterDateFrom">Date From</label>
                            <input class="form-control" id="transactionFilterDateFrom"
                                [(ngModel)]="transactionFilterDateFrom"
                                ngbDatepicker #d="ngbDatepicker"
                                (click)="d.toggle()"
                                placeholder="yyyy-mm-dd">
                        </div>
                        <div class="col-md-2">
                            <label class="col-form-label" for="transactionFilterDateTo">Date To</label>
                            <input class="form-control" id="transactionFilterDateTo"
                                [(ngModel)]="transactionFilterDateTo"
                                ngbDatepicker #d1="ngbDatepicker"
                                (click)="d1.toggle()"
                                placeholder="yyyy-mm-dd">
                        </div>
                        <div class="col-md-2">
                            <label class="col-form-label" for="transactionFilterStatus">Status</label>
                            <ng-select id="transactionFilterStatus"
                                [(ngModel)]="transactionFilterStatus"
                                placeholder="Select Status"
                                [inputAttrs]="{maxlength: '100'}">
                                <ng-option value="">All Status</ng-option>
                                <ng-option value="SUCCESS">Success</ng-option>
                                <ng-option value="FAILED">Failed</ng-option>
                                <ng-option value="PENDING">Pending</ng-option>
                                <ng-option value="ON_HOLD">On Hold</ng-option>
                                <ng-option value="CANCELLED">Cancelled</ng-option>
                                <ng-option value="REVERSED">Reversed</ng-option>
                                <ng-option value="REFUNDED">Refunded</ng-option>
                                <ng-option value="INITIATED">Initiated</ng-option>
                                <ng-option value="APPROVED">Approved</ng-option>
                                <ng-option value="REJECTED">Rejected</ng-option>
                                <ng-option value="RETRIED">Retried</ng-option>
                                <ng-option value="CLEARED">Cleared</ng-option>
                                <ng-option value="MATCHED">Matched</ng-option>
                                <ng-option value="PAY">Pay</ng-option>
                                <ng-option value="DECLINE">Decline</ng-option>
                                <ng-option value="EXPIRED">Expired</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-2">
                            <label class="col-form-label" for="transactionFilterTxnId">Transaction Identifier</label>
                            <input class="form-control" id="transactionFilterTxnId"
                                [(ngModel)]="transactionFilterTxnId"
                                type="text"
                                placeholder="Filter by Txn ID">
                        </div>
                        <div class="col-md-2">
                            <label class="col-form-label" for="transactionFilterOriginalTxnId">Original Transaction Identifier</label>
                            <input class="form-control" id="transactionFilterOriginalTxnId"
                                [(ngModel)]="transactionFilterOriginalTxnId"
                                type="text"
                                placeholder="Filter by Original Txn ID">
                        </div>
                        <div class="col-md-4 d-flex align-items-end gap-2">
                            <button class="btn btn-primary flex-fill" (click)="applyTransactionFilters()">
                                <i class="fa fa-search me-1"></i> Search
                            </button>
                            <button class="btn btn-secondary flex-fill" (click)="resetTransactionFilters()">
                                <i class="fa fa-refresh me-1"></i> Reset
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-0" style="min-height: 470px">
                <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                    <ag-grid-angular [enableCellTextSelection]=true [columnDefs]="transactionTableSelectedColumn"
                        [defaultColDef]="defaultColDef" [paginationPageSize]="pageSize"
                        [pagination]="true" [rowData]="transactionDetails" (gridReady)="onTransactionGridReady($event)"
                        [rowModelType]="" [rowSelection]="'single'" [suppressPaginationPanel]="true"
                        style="width: 100%; height: auto;">
                    </ag-grid-angular>
                </div>
            </div>
            <div class="row mt-0">
                <div class="col-4 col-xs-4 d-flex">
                    <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
                        class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
                        <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
                    </select>
                    <p class="text-muted p-3"> Total Records: {{ totalRecords }}</p>
                </div>
                <div class="col-8 col-xs-8">
                    <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage"
                        [boundaryLinks]="true" [collectionSize]="totalRecords" [maxSize]="5" [pageSize]="pageSize"
                        [rotate]="false" [directionLinks]="true" [ellipses]="false" size="sm"
                        class="d-flex justify-content-end align-right">
                    </ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</div>
